import { useCallback, useEffect, useState } from 'preact/hooks';

const getFlooredTime = () => Math.floor(Date.now() / 1000) * 1000;
const getFlooredDate = () => new Date(getFlooredTime());

export const useLatestActiveDate = () => {
  const [date, setDate] = useState(getFlooredDate);

  const reload = useCallback(() => {
    setDate(getFlooredDate());
  }, []);

  useEffect(() => {
    const handler = () => {
      setDate(getFlooredDate());
    };

    document.addEventListener('visibilitychange', handler);

    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, []);

  return [date, reload] as const;
};

export const useLatestActiveTime = () => {
  const [date, setDate] = useState(getFlooredTime);

  const reload = useCallback(() => {
    setDate(getFlooredTime());
  }, []);

  useEffect(() => {
    const handler = () => {
      setDate(getFlooredTime());
    };

    document.addEventListener('visibilitychange', handler);

    return () => {
      document.removeEventListener('visibilitychange', handler);
    };
  }, []);

  return [date, reload] as const;
};
